export default __webpack_public_path__ + "static/media/planpricingtooltips.f706387e.svg";